import { Component, model, input } from '@angular/core';

/**
 * The row above every URL table: "N urls matching" count, a slot for extra
 * filter dropdowns, a search box, and a slot for the action button(s)
 * ("Launch the crawl" / "Launch the discovery" / ...).
 */
@Component({
  selector: 'app-single-crawler-list-toolbar',
  templateUrl: './single-crawler-list-toolbar.component.html',
  styleUrls: ['./single-crawler-list-toolbar.component.scss'],
})
export class SingleCrawlerListToolbarComponent {
  query = model<string>();
  readonly count = input(0);
  readonly labelKey = input<string>();
  readonly noticeMessage = input<string>();
  readonly countLabelKeySingular = input('');
  readonly countLabelKeyPlural = input('');
  readonly searchPlaceholderKey = input('ACTIONS.SEARCH');
  // Steps whose backend does not support a free-text query can hide the box.
  readonly showSearch = input(true);
}
